
import { cn } from "@/lib/utils";

export type TagType = 'interest' | 'preference' | 'reminder' | 'avoid';

interface PreferenceTagProps {
  label?: string;
  type?: TagType;
  onClick?: () => void;
  removable?: boolean;
  onRemove?: () => void;
  children?: React.ReactNode;
}

const tagColors: Record<TagType, string> = {
  interest: "bg-purple-100 text-purple-800",
  preference: "bg-blue-100 text-blue-800",
  reminder: "bg-amber-100 text-amber-800",
  avoid: "bg-coral-100 text-coral-800",
};

const PreferenceTag = ({
  label,
  type = "interest",
  onClick,
  removable = false,
  onRemove,
  children,
}: PreferenceTagProps) => {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium",
        tagColors[type],
        onClick ? "cursor-pointer" : ""
      )}
      onClick={onClick}
    >
      <span>{children || label}</span>
      {removable && (
        <button
          type="button"
          className="ml-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-opacity-20"
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
        >
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L7 7M1 7L7 1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default PreferenceTag;
